import React, { useState } from 'react';
import { useViewport } from 'components/templates/viewportProvider';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { PaginationControl } from 'components/molecules/paginationControl';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropertyMobile from 'components/templates/propertyFeature/propertyFeatureMobile';
import { chunk } from 'lodash';
import './styles.scss';

export const PropertyFeature = props => {
  const { isMobile, height } = useViewport();
  const [sliderRef, setSlider] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const { features, banner } = props.data;
  let PropertyData = chunk(features && features, 4);
  const handleSliderRef = ref => {
    setSlider(ref);
  };
  const next = () => {
    sliderRef.slickNext();
  };

  const previous = () => {
    sliderRef.slickPrev();
  };
  const lengthOfSliders =
    PropertyData.length && PropertyData.length > 2
      ? PropertyData.length - 1
      : 1;
  return (
    <>
      {!isMobile ? (
        <div
          className={'property-container'}
          style={{ height }}
          id={'property-feature'}
        >
          <Row>
            <Col md={{ span: 5, offset: 0 }} className="column">
              <div className={'feature-image'}>
                <img
                  src={banner.property_feature_image}
                  alt="image"
                  className={'image'}
                />
              </div>
            </Col>
            <Col md={{ span: 7 }}>
              <div className={'feature-details'}>
                <h1 className={'main-heading'}>{banner.property_heading}</h1>
                <h3 className={'tag-word'}>{banner.property_tag_word}</h3>
                <HorizontalCarousel
                  data={PropertyData}
                  type={'property-feature'}
                  cssFor={'property-feature'}
                  getActiveSlide={e => {
                    setActiveSlide(e);
                  }}
                  handleSliderRef={handleSliderRef}
                />
              </div>
            </Col>
          </Row>
          <div className="section-footer show-explore">
            <PaginationControl
              className={'section-footer-item'}
              theme={'light-theme'}
              currentIndex={activeSlide + 1}
              total={lengthOfSliders}
              onNextClick={next}
              onPreviousClick={previous}
              key={'17'}
            />
          </div>
        </div>
      ) : (
        <PropertyMobile props={features} data={banner} />
      )}
    </>
  );
};
